import React, { ChangeEvent, Ref } from 'react';
import { bg200, bgPrimary } from '@osmosis/tailwind-ui/styles/background';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { ButtonProps } from '@osmosis/tailwind-ui/components/Button';

type Props = {
  onChange?: (e: ChangeEvent) => void;
  checked?: boolean;
  padding?: number;
  size?: number;
  color?: string;
  offColor?: string;
  'data-testid'?: string;
  buttonProps?: ButtonProps & { ref?: Ref<HTMLButtonElement> };
  style?: React.CSSProperties;
  'aria-label'?: string;
};

/**
 * Toggle button.
 */
export const Toggle = (props: Props) => {
  const {
    size = 20,
    color = bgPrimary,
    offColor = bg200,
    checked,
    onChange,
    style,
    buttonProps,
    'aria-label': ariaLabel,
  } = props as Props & { offColor?: string };

  const padding = 0.25 * size;

  return (
    <Button
      {...buttonProps}
      role="checkbox"
      data-testid="toggle-button"
      aria-label={ariaLabel}
      aria-checked={checked}
      className={`cursor-pointer rounded-full shadow-inner transition-colors duration-300 ease-in-out ${
        checked ? color : offColor
      } relative`}
      style={{
        ...style,
        width: size * 2.5,
        height: size + padding * 2,
      }}
      onClick={onChange as any}
    >
      <Box
        className={`transform rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out`}
        data-testid={props['data-testid']}
        style={{
          position: 'absolute',
          left: checked ? `calc(100% - ${size + padding}px)` : `${padding}px`,
          content: '',
          height: size,
          width: size,
          bottom: `${padding}px`,
          backgroundColor: 'textInvert',
          transition: '0.4s',
          borderRadius: '50%',
        }}
      />
    </Button>
  );
};
